import {
    faFacebook,
    faInstagram,
    faTwitter,
} from '@fortawesome/free-brands-svg-icons'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'

export default function Footer() {
  return (
    <footer
      id="footer"
      className={`text-sm mt-auto border-t border-white/20 bg-white/80 backdrop-blur-xl px-4 pt-8 text-neutral-600 dark:border-neutral-800/50 dark:bg-neutral-950/80 dark:text-neutral-400 pb-8 transition-all duration-300`}
    >
      <div className="container mx-auto flex max-w-3xl flex-col items-center justify-between gap-6 text-center md:flex-row md:text-left">
        <div className="flex flex-col items-center gap-3 md:flex-row md:items-center">
          <div className="relative">
            <img
              width={64}
              height={64}
              src="/tesseract-dark.svg"
              alt="Strangeways Developments"
              className="inline-flex h-12 w-auto items-center justify-center transition-all duration-300 hover:scale-110 dark:hidden"
            />
            <img
              width={64}
              height={64}
              src="/tesseract-light.svg"
              alt="Strangeways Developments"
              className="hidden h-12 w-auto items-center justify-center transition-all duration-300 hover:scale-110 dark:inline-flex"
            />
          </div>
          <span className="text-xs mt-1 uppercase tracking-wide text-gray-800 dark:text-neutral-500 md:ml-3 md:mt-0">
            © {new Date().getFullYear()} strangeways.ca
          </span>
        </div>
        <div id="social" className="inline-flex items-center gap-3">
          <a
            href="https://www.instagram.com/strangewaysstudios/"
            target="_blank"
            className="p-2 rounded-full border border-white/20 bg-white/50 backdrop-blur-sm transition-all duration-300 hover:bg-brand-500 hover:text-white hover:scale-110 hover:shadow-brand-500/25 dark:border-neutral-800/50 dark:bg-neutral-900/50 dark:hover:bg-brand-500"
          >
            <FontAwesomeIcon size="lg" icon={faInstagram} />
          </a>
          <a
            href="https://www.facebook.com/strangeways.co/"
            target="_blank"
            className="p-2 rounded-full border border-white/20 bg-white/50 backdrop-blur-sm transition-all duration-300 hover:bg-brand-500 hover:text-white hover:scale-110 hover:shadow-brand-500/25 dark:border-neutral-800/50 dark:bg-neutral-900/50 dark:hover:bg-brand-500"
          >
            <FontAwesomeIcon size="lg" icon={faFacebook} />
          </a>
          <a
            href="https://twitter.com/strangewaysltd"
            target="_blank"
            className="p-2 rounded-full border border-white/20 bg-white/50 backdrop-blur-sm transition-all duration-300 hover:bg-brand-500 hover:text-white hover:scale-110 hover:shadow-brand-500/25 dark:border-neutral-800/50 dark:bg-neutral-900/50 dark:hover:bg-brand-500"
          >
            <FontAwesomeIcon size="lg" icon={faTwitter} />
          </a>
        </div>
      </div>
    </footer>
  )
}
